"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const validators_1 = require("../../utils/validators");
class AuthController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            login: '/v1/login',
            logout: '/v1/logout',
            getTotp: '/v1/auth/totp/get',
            setTotp: '/v1/auth/totp/set',
            unsetTotp: '/v1/auth/totp/unset',
            unsetTotpForUser: '/v1/auth/totp/unset/:userId',
            passwordPolicy: '/v1/auth/local/passwordPolicy',
            sendPassword: 'v1/sendPasswordResetMail',
            changePassword: 'v1/changePassword',
        };
    }
    list() {
        throw new Error("Can't list auth");
    }
    count() {
        throw new Error("Can't count auth");
    }
    create({}) {
        throw new Error("Can't create auth!");
    }
    edit({}) {
        throw new Error("Can't edit auth!");
    }
    delete() {
        throw new Error("Can't delete auth!");
    }
    login(data) {
        const { user, password } = data;
        (0, validators_1.isRequired)(user, password);
        return this.manager.post({ url: this.endpoints.login }, data);
    }
    logout() {
        return this.manager.post({ url: this.endpoints.logout });
    }
    getMFASecret() {
        return this.manager.get({ url: this.endpoints.getTotp });
    }
    setMFASecret(code, secret) {
        return this.manager.post({ url: this.endpoints.setTotp }, { code, secret });
    }
    unsetMFA() {
        return this.manager.post({ url: this.endpoints.unsetTotp });
    }
    unsetMFAForUser(userId) {
        return this.manager.post({ url: this.endpoints.unsetTotpForUser, params: { userId } });
    }
    getPasswordPolicy() {
        return this.manager.get({ url: this.endpoints.passwordPolicy });
    }
    sendPasswordMail(login) {
        return this.manager.post({ url: this.endpoints.sendPassword }, { user: login });
    }
    changePassword({ password, secret }) {
        return this.manager.post({ url: this.endpoints.changePassword }, { password, secret });
    }
}
exports.default = AuthController;
